export default "__VITE_ASSET__afd37801__"